import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import MeasureUnitHelper from "@Scripts/Infrastructure/MeasureUnitHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import FormHelper from "@Scripts/Common/FormHelper";

@Component({ name: "CatalogueProductItem" })
export default class CatalogueProductItem extends Vue {
    public localizer: any = Localizer;
    public measureUnitHelper: any = MeasureUnitHelper;
    public isFavoriteOpened: boolean = false;
    public isFavorite: boolean = false;
    public isLoading: boolean = false;
    public validationErrors: any[] = [];
    public isLoadingForm: boolean = false;

    get routes() {
        return (<any>window).App.routes;
    }

    get measureUnits() {
        return this.$store.getters["measureUnitStore/measureUnits"];
    }

    @Prop() readonly productItem: any;
    @Prop() readonly topProductFields: string[];
    @Prop() readonly page: string;
    @Prop() readonly iscct: boolean;
    @Prop() readonly isAuthenticated: boolean;

    public setCamelCase(value: string) {
        return value.charAt(0).toLowerCase() + value.slice(1);
    }

    public setAnalytics(key: string) {
        if (this.page == "family") {
            switch (key) {
                case "Detail":
                    GTagHelper.sendEvent("click", "family_interaction", "detail");
                    break;
                case "UpdateAvailability":
                    GTagHelper.sendEvent("click", "family_interaction", "update_availability");
                    break;
                case "TechnicalSheet":
                    GTagHelper.sendEvent("file_download", "family_interaction", "technical_sheet");
                    break;
                case "Expand":
                    GTagHelper.sendEvent("click", "family_interaction", "expand");
                    break;
            }
        } else if (this.page == "accessory") {
            switch (key) {
                case "Detail":
                    GTagHelper.sendEvent("click", "product_accessory", "detail");
                    break;
                case "UpdateAvailability":
                    GTagHelper.sendEvent("click", "product_accessory", "update_availability");
                    break;
                case "TechnicalSheet":
                    GTagHelper.sendEvent("file_download", "product_accessory", "technical_sheet");
                    break;
                case "Expand":
                    GTagHelper.sendEvent("click", "product_accessory", "expand");
                    break;
            }
        }
    }

    public openPdfUrl() {
        GTagHelper.sendEvent("click", "family_interaction", "technical_sheet");
        window.open(this.productItem.productViewPdfUrl, '_blank');
    }

    public async onExpMenu() {
        if (!this.isFavoriteOpened) {
            const result = (await Axios.post(this.routes.ProfileFavorite_IsFavorite, { productOrderCode: this.productItem.product.orderCode })).data;
            this.isFavorite = result.isFavorite;

            this.isFavoriteOpened = true;
        }
    }

    public async addToFavorite() {
        this.isLoading = true;
        await Axios.post(this.routes.ProfileFavorite_FavoriteAdd, { productOrderCode: this.productItem.product.orderCode });

        if (this.page == "family") {
            GTagHelper.sendEvent("click", "family_interaction", "favourite");
        } else if (this.page == "accessory") {
            GTagHelper.sendEvent("click", "product_accessory", "favourite");
        }

        this.$store.dispatch("appToastStore/onAddToast", { message: this.localizer.get("App.Common.AddedToFavorite"), type: "Success" });

        this.isFavorite = true;
        this.isLoading = false;
    }

    public async removeToFavorite() {
        this.isLoading = true;
        await Axios.post(this.routes.ProfileFavorite_FavoriteRemove, { productOrderCode: this.productItem.product.orderCode });

        if (this.page === "my-beghelli-favorite") {
            window.location.reload();
        }

        if (this.page == "family") {
            GTagHelper.sendEvent("click", "family_interaction", "favourite_remove");
        } else if (this.page == "accessory") {
            GTagHelper.sendEvent("click", "product_accessory", "favourite_remove");
        }

        this.$store.dispatch("appToastStore/onAddToast", { message: this.localizer.get("App.Common.RemovedToFavorite"), type: "Success" });

        this.isFavorite = false;
        this.isLoading = false;
    }

    public async addProduct() {
        FormHelper.removeFocus();
        this.isLoadingForm = true;
        this.validationErrors = [];

        try {
            await Axios.post(this.routes.StoreCart_AddProduct, { productCode: this.productItem.product.orderCode, productQuantity: 1 });

            this.$store.dispatch("cartStore/getCart");

            this.$store.commit("cartStore/setIsCartPreviewShow", true);

            GTagHelper.sendCustomEvent("add_to_cart", {
                currency: "EUR",
                value: this.productItem.product.priceOffer ? this.productItem.product.priceOffer : this.productItem.product.price,
                items: [
                    {
                        item_id: this.productItem.product.orderCode,
                        item_name: this.productItem.product.title,
                        affiliation: "Beghelli",
                        currency: "EUR",
                        item_category: this.productItem.product.categoryName,
                        price: this.productItem.product.price,
                        discount: this.productItem.product.priceOffer ? this.productItem.product.price - this.productItem.product.priceOffer : 0,
                        quantity: 1
                    }
                ]
            });
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);

                for (const iterator of this.validationErrors) {
                    this.$store.dispatch("appToastStore/onAddToast", { message: iterator.message, type: "Alert" });
                }
            }
        }

        this.isLoadingForm = false;
    }

    public formatPrice(data: number) {
        return new Intl.NumberFormat('it-IT', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(data);
    }

    public setAccordion(productId: string): void {
        let accordion = document.querySelector("#" + productId);

        accordion.classList.toggle("active");

        const thisExp: HTMLElement = accordion.querySelector(".exp");
        if (accordion.classList.contains('active')) {
            thisExp.style.height = thisExp.scrollHeight + 'px';
            this.setAnalytics("Expand");
        } else {
            thisExp.style.height = '0';
        }
    }
};